<template>
  <order-list :draft="10"/>
</template>

<script>
  import OrderList from "./OrderList.vue";
  export default {
    components: {
      OrderList,
    },
  };
</script>
<style scoped></style>
